import { Text } from '@cellula/react';
import { tokens } from '@cellula/react-theme-patient';
import { ExternalSvg } from '@components/external_svg.component';
import { Icon, IconType } from '@components/icon.component';
import { VStack } from '@components/v_stack.component';
import { FlexibleButtonIconModel } from '@services/flexible_component/mod';
import { theme } from '@services/theme.service/theme';
import { rem } from '@visiba/std';
import styled from 'styled-components';
import { Routeable } from './_flexible_identifier_routeable.component';

interface Props {
	component: FlexibleButtonIconModel;
	__TEMP__on_OPW_WebContentButton_proxy_invoke?: (flexibleIdentifierData: {
		url: string;
		openUrlWith: string;
		requiresAuthentication: boolean;
	}) => void;
}

const elements = {
	button: styled.div`
		display: flex;
		align-items: center;
		width: 100%;
		background: ${theme.primary};
		border-radius: ${rem(10)};
		min-height: ${rem(64)};
		padding-top: ${tokens.spacing.x2};
		padding-bottom: ${tokens.spacing.x2};
		color: #fff;
	`,
	icon: styled.div`
		margin: 0 ${rem(20)};
		width: ${rem(24)};
		height: ${rem(24)};
		display: flex;
		justify-content: center;
		align-items: center;
		font-size: ${rem(24)};
		color: #fff;
		flex-shrink: 0;
	`,
};

export function FlexibleButtonIcon({ component, __TEMP__on_OPW_WebContentButton_proxy_invoke, ...rest }: Props): JSX.Element {
	const renderIcon = () => {
		if (component.icon?.type == 'local') {
			return <Icon type={component.icon.origin as IconType} />;
		}
		if (component.icon?.type == 'svgUrl') {
			return <ExternalSvg imgSrc={component.icon.origin} size={24} />;
		}
		if (component.icon?.type == 'pngUrl') {
			return <img src={component.icon.origin} height={24} alt='' />;
		}
		return null;
	};

	return (
		<Routeable
			url={component.url}
			requiresAuthentication={component.requiresAuthentication}
			openWith={component.openUrlWith}
			sourceButtonId={component.id}
			__TEMP__on_OPW_WebContentButton_proxy_invoke={__TEMP__on_OPW_WebContentButton_proxy_invoke}
			{...rest}
		>
			<elements.button data-testid='FlexibleButtonIcon'>
				<elements.icon>{renderIcon()}</elements.icon>

				<VStack fluid={false}>
					<Text variant='bodyLargeRegular'>{component.title}</Text>
					{component.subtitle ? <Text variant='bodyRegular'>{component.subtitle}</Text> : null}
				</VStack>
			</elements.button>
		</Routeable>
	);
}
